module.exports = __webpack_public_path__ + "static/media/comp2.f954b07b.png";